import { createActions, handleActions } from 'redux-actions';

import apiCall from '../api';

const defaultState = {
  loading: false,
  error: null,
  data: {
    totalUsers: 0,
    activeUsers: 0,
    maleUsers: 0,
    femaleUsers: 0,
    deletedUsers: 0,
    blockedUsers: 0,
    onlineUsers: 0,
    totalPhotos: 0,
    activePhotos: 0,
    deletedPhotos: 0,
    explicitPhotos: 0,
    totalMatches: 0,
    activeMatches: 0,
    deletedMatches: 0,
    totalMessages: 0,
    totalSwipes: 0,
  }
};

const _actions = createActions({
  dashboard: {
    load: () => async (dispatch, getState) => {
      if (getState().dashboard.loading) {
        return;
      }
      dispatch(actions.setLoading(true));
      const result = await apiCall('/dashboard', { method: 'GET' });
      dispatch(actions.setLoading(false));
      if (!result.success) {
        dispatch(actions.setError('Error loading data'));
      } else {
        dispatch(actions.setData(result.payload));
      }
    },
    setLoading: payload => payload,
    setError: payload => payload,
    setData: payload => payload
  }
});
const actions = _actions.dashboard;

const setLoading = (state, action) => {
  return Object.assign({}, state, { loading: action.payload });
};
const setError = (state, action) => {
  return Object.assign({}, state, { error: action.payload });
};

const setData = (state, action) => {
  return Object.assign({}, state, {data: action.payload});
};

const reducer = handleActions(
  {
    [actions.setLoading]: setLoading,
    [actions.setError]: setError,
    [actions.setData]: setData
  },
  defaultState
);

export { actions, reducer };
